import { render, staticRenderFns } from "./PrivacyProtocol.vue?vue&type=template&id=291d07df&scoped=true"
import script from "./PrivacyProtocol.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocol.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocol.vue?vue&type=style&index=0&id=291d07df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d07df",
  null
  
)

export default component.exports